import * as features from './features'

export default {
  login: {
    type: 'login',
    endpoint: '/login',
    features: [features.create],
  },
  cartDiscounts: {
    type: 'cart-discounts',
    endpoint: '/cart-discounts',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  carts: {
    type: 'carts',
    endpoint: '/carts',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  categories: {
    type: 'categories',
    endpoint: '/categories',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  channels: {
    type: 'channels',
    endpoint: '/channels',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  customerGroups: {
    type: 'customer-groups',
    endpoint: '/customer-groups',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  customers: {
    type: 'customers',
    endpoint: '/customers',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  customersPassword: {
    type: 'customers-password',
    endpoint: '/customers/password',
    features: [features.create],
  },
  customersPasswordToken: {
    type: 'customers-password-token',
    endpoint: '/customers/password-token',
    features: [features.create, features.queryOne],
  },
  customersPasswordReset: {
    type: 'customers-password-reset',
    endpoint: '/customers/password/reset',
    features: [features.create],
  },
  customersEmailVerificationToken: {
    type: 'customers-email-verification-token',
    endpoint: '/customers/email-token',
    features: [features.create, features.queryOne],
  },
  customersEmailVerification: {
    type: 'customers-email-verification',
    endpoint: '/customers/email/confirm',
    features: [features.create],
  },
  customObjects: {
    type: 'custom-objects',
    endpoint: '/custom-objects',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  discountCodes: {
    type: 'discount-codes',
    endpoint: '/discount-codes',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  extensions: {
    type: 'extensions',
    endpoint: '/extensions',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  inventory: {
    type: 'inventory',
    endpoint: '/inventory',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  messages: {
    type: 'messages',
    endpoint: '/messages',
    features: [features.query, features.queryOne, features.queryExpand],
  },
  myActiveCart: {
    type: 'my-carts',
    endpoint: '/me/active-cart',
    features: [features.queryOne],
  },
  myCarts: {
    type: 'my-carts',
    endpoint: '/me/carts',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  myOrders: {
    type: 'my-orders',
    endpoint: '/me/orders',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  orders: {
    type: 'orders',
    endpoint: '/orders',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  orderEdits: {
    type: 'orders-edits',
    endpoint: '/orders/edits',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  orderImport: {
    type: 'orderImport',
    endpoint: '/orders/import',
    features: [features.create, features.query],
  },
  payments: {
    type: 'payments',
    endpoint: '/payments',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  productDiscounts: {
    type: 'product-discounts',
    endpoint: '/product-discounts',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  productProjections: {
    type: 'product-projections',
    endpoint: '/product-projections',
    features: [
      features.query,
      features.queryOne,
      features.queryExpand,
      features.projection,
    ],
  },
  productProjectionsSearch: {
    type: 'product-projections-search',
    endpoint: '/product-projections/search',
    features: [
      features.search,
      features.queryOne,
      features.queryExpand,
      features.projection,
    ],
  },
  productProjectionsSuggest: {
    type: 'product-projections-suggest',
    endpoint: '/product-projections/suggest',
    features: [
      features.search,
      features.suggest,
      features.queryOne,
      features.projection,
    ],
  },
  products: {
    type: 'products',
    endpoint: '/products',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  productTypes: {
    type: 'product-types',
    endpoint: '/product-types',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  project: {
    type: 'project',
    endpoint: '/',
    features: [features.update, features.query],
  },
  reviews: {
    type: 'reviews',
    endpoint: '/reviews',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  shippingMethods: {
    type: 'shipping-methods',
    endpoint: '/shipping-methods',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
      features.queryLocation,
    ],
  },
  shoppingLists: {
    type: 'shopping-lists',
    endpoint: '/shopping-lists',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  states: {
    type: 'states',
    endpoint: '/states',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  stores: {
    type: 'stores',
    endpoint: '/stores',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  subscriptions: {
    type: 'subscriptions',
    endpoint: '/subscriptions',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  taxCategories: {
    type: 'tax-categories',
    endpoint: '/tax-categories',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  types: {
    type: 'types',
    endpoint: '/types',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
  zones: {
    type: 'zones',
    endpoint: '/zones',
    features: [
      features.create,
      features.update,
      features.del,
      features.query,
      features.queryOne,
      features.queryExpand,
    ],
  },
}
